module.exports = __webpack_public_path__ + "img/yts.13ff7072.png";